import { Link } from 'react-router-dom';
import { testimonials } from '@/mocks/home';

export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <span className="text-accent-600 text-sm font-semibold tracking-wide">用户口碑</span>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-2 mb-4">
                百万用户的选择
              </h2>
              <p className="text-foreground-600 text-sm leading-relaxed mb-8">
                自成立以来，开元体育已服务超过500万注册用户，以专业的服务和优质的产品赢得了广泛好评。
                加入开元体育，开启您的专业体育娱乐之旅。
              </p>

              <div className="space-y-4 mb-8">
                {testimonials.map((t) => (
                  <div key={t.name} className="bg-background-100 border border-background-200 rounded-lg p-4">
                    <div className="flex items-center gap-1 mb-2">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-2">&ldquo;{t.content}&rdquo;</p>
                    <p className="text-xs text-foreground-500">
                      {t.name} · {t.role}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <div className="relative rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Dramatic%20sports%20arena%20with%20warm%20golden%20atmosphere%20packed%20enthusiastic%20crowd%20celebrating%20cinematic%20lighting%20professional%20sports%20photography%20epic%20scale%20vibrant%20energy%20editorial%20style%20high%20contrast&width=700&height=500&seq=cta-sports&orientation=landscape"
                  alt="开元体育平台"
                  className="w-full h-80 md:h-96 object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="bg-background-50/95 backdrop-blur-sm rounded-lg p-5 border border-background-200">
                  <h3 className="font-heading text-xl font-bold text-foreground-950 mb-2">
                    立即加入开元体育
                  </h3>
                  <p className="text-sm text-foreground-600 mb-4">
                    注册即享专属新人礼包，开启专业体育娱乐体验！
                  </p>
                  <Link
                    to="/category/promotions"
                    className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                  >
                    立即注册 <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}